const DISMISSED_KEY = 'aurax_dismissed_announcements';
const APPLIED_VERSION_KEY = 'aurax_applied_panel_version';

export function getDismissedAnnouncements() {
  try {
    const raw = localStorage.getItem(DISMISSED_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function dismissAnnouncement(id) {
  if (!id) return;
  const current = getDismissedAnnouncements();
  if (!current.includes(id)) {
    current.push(id);
    localStorage.setItem(DISMISSED_KEY, JSON.stringify(current.slice(-50)));
  }
}

export function markVersionApplied(version) {
  if (!version) return;
  localStorage.setItem(APPLIED_VERSION_KEY, String(version));
}

export function getAppliedVersion() {
  return localStorage.getItem(APPLIED_VERSION_KEY) || '';
}

export async function hardReloadApp(version) {
  try {
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    }
    if ('caches' in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
  } catch {
    /* ignore */
  }

  window.location.replace(buildUpdateUrl(window.location.href, version));
}

export function buildUpdateUrl(href, version) {
  const url = new URL(href);
  url.searchParams.set('_aurax_v', version || String(Date.now()));
  return url.href;
}

// The cache-buster is needed for the navigation, then removed before the router
// reads its initial location. Keep unrelated filters, fragment and history state.
export function cleanAppliedUpdateUrl(target = window) {
  try {
    const url = new URL(target.location.href);
    if (!url.searchParams.has('_aurax_v')) return false;
    url.searchParams.delete('_aurax_v');
    target.history.replaceState(target.history.state, '', url.pathname + url.search + url.hash);
    return true;
  } catch {
    return false;
  }
}
